import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'Components/UI/Button';
import PlanoAvisoPersonalizationUpgrade from 'Static/images/plano-aviso-personalization-upgrade.png';
import tagEnterprise from 'Static/images/tag-enterprise.png';
import { Icon } from 'Components/UI';
import { TagWrapper } from './styles';

interface IPersonalizationCTAUpgrade {
  onConfirm: (role: number, order: number) => void;
  order?: number;
  role?: number;
}

const PersonalizationCTAUpgrade: FC<IPersonalizationCTAUpgrade> = ({
  onConfirm,
  order,
  role,
}) => {
  const { t } = useTranslation('personalization');
  const isAdmin = role === 1;
  const isStart = (order || 0) <= 1;

  return (
    <TagWrapper>
      <div className="wrapper">
        <div className="tag-popularity">
          <img src={tagEnterprise} alt={t('ctaUpgrade.tagImgAlt')} />
        </div>
        <div className="imageWrapper">
          <img src={PlanoAvisoPersonalizationUpgrade} alt={t('ctaUpgrade.ctaImgAlt')} />
        </div>
        <div className={`contentWrapper ${!isStart ? 'contentWrapperPro' : ''}`}>
          <div>
            <label className="avisoLimiteObras">
              {isAdmin
                ? t('ctaUpgrade.warningPersonal')
                : t('ctaUpgrade.warningCompany')
              }
            </label>
          </div>
          <h2>
            {isStart
              ? isAdmin
                  ? t('ctaUpgrade.upgradeHeadingFreePersonal')
                  : t('ctaUpgrade.upgradeHeadingFreeCompany')
              : isAdmin
                  ? t('ctaUpgrade.upgradeHeadingProPersonal')
                  : t('ctaUpgrade.upgradeHeadingProCompany')
            }
          </h2>
          <h3>
            {isAdmin
              ? t('ctaUpgrade.upgradeSubheadingPersonal')
              : t('ctaUpgrade.upgradeSubheadingCompany')
            }
          </h3>
          {isStart && (
            <>
              <p>{t('ctaUpgrade.enterpriseProvides')}</p>
              <div className="icons-wrapper">
                <div className={`icons-text-wrapper icons-text-margin`}>
                  <div>
                    <Icon icon={'arquivo3d'} size={'xs'} customColor={'#8697A8'} style={{ paddingLeft: 0, marginLeft: 0 }} />
                    <span>{t('ctaUpgrade.feature2d3d')}</span>
                  </div>
                  <div>
                    <Icon icon={'estrelaVazia'} size={'xs'} customColor={'#8697A8'} style={{ paddingLeft: 0, marginLeft: 0 }} />
                    <span>{t('ctaUpgrade.featureNomenclature')}</span>
                  </div>
                  <div>
                    <Icon icon={'activities'} customSize={16} customColor={'#8697A8'} style={{ paddingLeft: 0, marginLeft: 0 }} />
                    <span>{t('ctaUpgrade.featureActivities')}</span>
                  </div>
                </div>
                <div className="icons-text-wrapper">
                  <div>
                    <Icon icon={'menuGerenciarUsuario'} size={'xs'} customColor={'#8697A8'} />
                    <span>{t('ctaUpgrade.featureUserManagement')}</span>
                  </div>
                  <div>
                    <Icon icon={'menuPlotagem'} size={'xs'} customColor={'#8697A8'} />
                    <span>{t('ctaUpgrade.featurePlotting')}</span>
                  </div>
                </div>
                <div style={{ marginBottom: 14 }}>&nbsp;</div>
              </div>
            </>
          )}

          <div className="button-wrapper">
            <Button
              className="button-confirm"
              type='primary'
              ispremium="true"
              width={228}
              height={48}
              onClick={() => onConfirm(role || 0, order || 0)}
            >
              <Icon icon="crown" className="icon" size="xxs" color="cinzaEscuro" />
              {isAdmin
                  ? t('ctaUpgrade.acquireEnterprisePersonal')
                  : t('ctaUpgrade.acquireEnterpriseCompany')
              }
            </Button>
          </div>
        </div>
      </div>
    </TagWrapper>
  );
};

export default PersonalizationCTAUpgrade;
